import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Aurora } from "@/components/motion/Aurora";

const BG =
  "https://images.unsplash.com/photo-1610114884987-181c872a64bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxyb2FkJTIwdHJpcCUyMGZvcmVzdCUyMGhpZ2h3YXl8ZW58MHx8fHwxNzc4NDIyNTUzfDA&ixlib=rb-4.1.0&q=85";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("propietario@camper.es");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aurora-page relative isolate min-h-screen grid lg:grid-cols-2">
      <Aurora variant="subtle" fixed />
      <div className="relative hidden lg:block">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-forest-deep/70" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="text-overline hover:underline" data-testid="admin-back-home">
            ← VanCheck
          </Link>
          <div>
            <span className="text-overline text-warn">Panel propietario</span>
            <h1 className="font-display text-5xl font-semibold tracking-tight mt-3 leading-[0.95]">
              Gestiona tus
              <br />
              reservas Yescapa.
            </h1>
            <p className="text-white/80 mt-6 max-w-md leading-relaxed">
              Crea reservas, comparte códigos con tus clientes y revisa
              check-ins, fotos, firmas e incidencias en un solo lugar.
            </p>
          </div>
          <div className="text-xs text-white/60">
            Volkswagen California Ocean · Yescapa #91679
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-ivory">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="lg:hidden inline-flex items-center text-sm text-warmgray mb-8"
            data-testid="admin-mobile-back"
          >
            <ArrowLeft className="h-4 w-4 mr-1" /> Volver
          </Link>
          <div className="h-12 w-12 bg-forest-deep rounded-xl flex items-center justify-center text-white mb-6">
            <Lock className="h-5 w-5" strokeWidth={1.8} />
          </div>
          <h2 className="font-display text-3xl font-bold tracking-tight text-charcoal mb-2">
            Acceso propietario
          </h2>
          <p className="text-warmgray mb-8">
            Introduce tus credenciales para gestionar la flota.
          </p>
          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email" className="text-charcoal">Correo</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 bg-white border-sand h-12"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-charcoal">Contraseña</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 bg-white border-sand h-12"
                data-testid="admin-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-forest-deep hover:bg-forest text-white h-12 text-base"
              data-testid="admin-login-submit"
            >
              {loading ? "Entrando..." : "Entrar al panel"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
